import { animate, createScope } from 'animejs';
import { useEffect, useRef } from 'react';

function TitansHero2() {
  
  const tenPlayers = useRef(null);
  const scope = useRef(null);

  useEffect(() => {
    
      scope.current = createScope({ tenPlayers }).add( self => {
      
        // Every anime.js instance declared here is now scoped to <div ref={root}>
  
        // Created a sliding animation loop
        animate('.tenPlayers', 
          { translateY: [100, 0],
            opacity: [0, 1],
            easing: 'easeOutExpo',
          });
      });
  
      // Properly cleanup all anime.js instances declared inside the scope
      return () => scope.current.revert()
  
    }, []);

  return (
    <>
      <div className="container-fluid position-relative p-0 d-none d-md-block">
        {/* Background image */}
        <div className=''>
          <img
            src="./s3/10_player_bg.jpg"
            alt="Background"
            className="w-100 d-block"
          />
        </div>
        {/* Transparent overlay */}
        <div className='tenPlayers position-absolute start-0 top-0 w-100 h-100'>
          <img
            src="./s3/10_player_montage.png"
            alt="Players"
            className="w-100"
          />
        </div>
      </div>
      <div className="d-block d-md-none">
        <img src="./s3/10_player_montage_mobile.jpg"
          className="w-100" 
          alt="ADS Sports Complex and ADS Titans are
            proud to welcome Coach Brandon Branch as the
            new ADS Titans Head Coach"
        />
      </div>
    </>
  );
}

export default TitansHero2;
